<template>
  <div>
    <b-modal ref="model_qs" title="提示" ok-title="确定" ok-only>
      <p>申请状态异常，请联系银行</p>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
var config = require("../../common/config.js");
export default {
  name: "BaseApplyAction",
  data() {
    return {
      bankCode: "",
      applyDetail: "",
      isInner: "",
    };
  },
  mounted: function () {
    this.applyDetail = this.$route.query.applyDetail;
    this.isInner = this.$route.query.isInner;
    // this.bankCode = this.$route.query.bankCode;
    this.decodeData(this.applyDetail);
  },
  methods: {
    toQishangBank: function (applyInfo) {
      this.$router.replace({
        name: "ApplyCard_qs", //
        params: {
          ...applyInfo,
        },
      });
    },
    decodeData: function (input) {
      let newinput = encodeURIComponent(input);
      //解密数据
      var that = this;

      var formData = new FormData();
      console.log("isInner->" + this.isInner);
      if ("inner" === this.isInner) {
        //公众号内部跳转到本页面
        formData.append("applyDetail", input);
        formData.append("bankCode", "0085");
      } else {
        //公众号外部跳转到本页面
        formData.append("applyDetail", newinput);
        formData.append("bankCode", "0085");
      }
      axios({
        method: "post",
        url: config.config_qs.getDecodeData,
        data: formData,
      })
        .then(function (response) {
          console.log(response);
          //{"checkStatus":"0","merchNo":"","mobileNo":"xx","flowNo":"500000000757468"}
          if (response.status == 200) {
            let data = response.data;
            if (data.checkStatus == "2") {
              that.showqsStateMsg();
              return;
            } else if (
              data.checkStatus == "0" ||
              data.checkStatus == "1" ||
              data.checkStatus == "3"
            ) {
              let params = data; // JSON.stringify(data);
              //申请卡页面
              // console.log("data", data);
              sessionStorage.setItem("entrance", 1);
              that.toQishangBank(params);
            }
          } else {
          }
          let dataRes = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    showqsStateMsg: function () {
      this.$refs["model_qs"].show();
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/qishangbank/BaseApplyAction_qs.vue